import styled, { keyframes } from 'styled-components';

const animation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const ActiveIndicator = styled.div`
  color: ${props => props.theme.color.primary};
  font-size: 11px;
  text-indent: -99999em;
  margin: 0 auto;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 36px;
  min-height: 36px;
  box-shadow: inset 0 0 0 0.3em;
  transform: translateZ(0);
  border-radius: 50%;
  &:before,
  &:after {
    position: absolute;
    content: '';
  }
  &:before {
    width: 52%;
    height: 102%;
    background: white;
    border-radius: 102% 0 0 102%;
    bottom: 0;
    left: -1px;
    transform-origin: right 51%;
    animation: ${animation} 2s infinite ease 1.5s;
  }
  &:after {
    width: 52%;
    height: 102%;
    background: white;
    border-radius: 0 102% 102% 0;
    bottom: 0;
    right: -1px;
    transform-origin: 0px 51%;
    animation: ${animation} 2s infinite ease;
  }
`;

export default ActiveIndicator;
